import { StockBlockItemStats } from 'volta/models/app-feature';
import {
  AcquisitionCodes,
  AcquisitionCodesArray,
  AcquisitionCodesOptions
} from 'volta/models/constants/acquisition-codes';
import { ADU_FREQUENCIES, ADU_FREQUENCIES_OPTIONS } from 'volta/models/constants/adu';
import { BvTableFeaturesIds } from 'volta/models/constants/app-features-columns';
import BufferZones, {
  BufferZonesIndex,
  BufferZonesOptions
} from 'volta/models/constants/buffer-zones';
import { Statuses } from 'volta/models/planning-order';
import { OrderCycleStrategiesOptions } from 'volta/models/constants/order-cycle-strategies';
import {
  ReorderStrategiesArray,
  ReorderStrategiesOptions
} from 'volta/models/constants/reorder-strategies';

import { helper } from '@ember/component/helper';

const Constants = {
  AcquisitionCodes,
  AcquisitionCodesOptions,
  AcquisitionCodesArray,
  BufferZones,
  BufferZonesIndex,
  BufferZonesOptions,
  StockBlockItemStats,
  BvTableFeaturesIds,
  ADU_FREQUENCIES,
  ADU_FREQUENCIES_OPTIONS,
  POStatusOptions: Statuses,
  OrderCycleStrategiesOptions,
  ReorderStrategiesArray,
  ReorderStrategiesOptions
};

function constant([key]: [key?: keyof typeof Constants] /*, hash*/) {
  return key ? Constants[key] : undefined;
}

const constantHelper = helper(constant);
export default constantHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    constant: typeof constantHelper;
  }
}
